import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";
import ValidationError from "../validationError";
import {ErrorType} from "~/enums/ErrorType";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class WorkflowStepDataViewerValidator extends NavigableValidator<WorkflowStep> {
  _validatorKey = "hasDataViewer"
  defaultType = ErrorType.invalidValue;

  _validate(model: WorkflowStep): void {
    if (model.areDataViewersConfigurable && !model.hasDataViewers) {
      this.errors.push(this.buildValidationError(model, 'At least one data viewer must be assigned.'));
    }
  }

  buildValidationError(model: WorkflowStep, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: `${model.titleOrDefault} (step)`,
      errorNavOpts: model.validation.errorNavOpts(this, this.validatorKey, model),
      type: type || this.defaultType,
      section: this.section
    });
  }
}